import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ConfiguracoesIA.css';

const ConfiguracoesIA = () => {
  const [iaAtiva, setIaAtiva] = useState(false);
  const [modelo, setModelo] = useState('');
  const [prompt, setPrompt] = useState('');
  const [modelosDisponiveis, setModelosDisponiveis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [modoTreinamento, setModoTreinamento] = useState(false);
  const [leadTreinamentoId, setLeadTreinamentoId] = useState('');
  const [leads, setLeads] = useState([]);
  const [inatividadeAtiva, setInatividadeAtiva] = useState(false);
  const [mensagemInatividade, setMensagemInatividade] = useState('');
  const [inatividadeHoras, setInatividadeHoras] = useState(4);
  const [novoLeadDias, setNovoLeadDias] = useState(2);
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const usuario_id = Number(usuario?.id || 0);
  const [mensagemSaudacao, setMensagemSaudacao] = useState('');
  const [limpando, setLimpando] = useState(false);


  const leadSelecionado = leads.find(l => String(l.id) === String(leadTreinamentoId));
  const telefoneLeadSelecionado = leadSelecionado?.telefone || '';


  // ADICIONE
const limparHistorico = async () => {
  if (!leadTreinamentoId) {
    setMensagem('Selecione um lead antes de limpar o histórico.');
    return;
  }
  if (!telefoneLeadSelecionado) {
    setMensagem('Não encontrei o telefone do lead selecionado. Atualize a lista de leads ou verifique o endpoint.');
    return;
  }

  const confirma = window.confirm(
    `Tem certeza que deseja apagar TODO o histórico deste lead?\n` +
    `Telefone: ${telefoneLeadSelecionado}\n` +
    `Essa ação não pode ser desfeita.`
  );
  if (!confirma) return;

  try {
    setLimpando(true);
    setMensagem('');

  await axios.post(
    'https://welaunchyou.com.br/crm-wly/api/openai/limpar_historico.php',
    { usuario_id, lead_id: leadTreinamentoId, telefone: telefoneLeadSelecionado || '' },
    { withCredentials: true, headers: { 'Content-Type': 'application/json' } }
  );


    setMensagem('Histórico apagado com sucesso!');
  } catch (err) {
    console.error('Erro ao limpar histórico:', err);
    setMensagem('Erro ao limpar histórico. Tente novamente.');
  } finally {
    setLimpando(false);
  }
};


  useEffect(() => {
    carregarConfiguracoes();
    carregarModelos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const carregarConfiguracoes = async () => {
    try {
      const res = await axios.get(
        'https://welaunchyou.com.br/crm-wly/api/openai/configuracoes.php',
        { params: { usuario_id }, withCredentials: true }
      );
      const dados = res.data;

      setIaAtiva(dados.ia_ativa === true || dados.ia_ativa === 1 || dados.ia_ativa === '1');
      setModelo(dados.modelo_openai || '');
      setPrompt(typeof dados.prompt_base === 'string' ? dados.prompt_base : '');
      setModoTreinamento(dados.modo_treinamento === 1 || dados.modo_treinamento === true);
      setLeadTreinamentoId(dados.lead_treinamento_id || '');
      setInatividadeAtiva(
        dados.inatividade_ativa === 1 || dados.inatividade_ativa === true || dados.inatividade_ativa === '1'
      );
      setMensagemInatividade(dados.mensagem_inatividade || '');
      setInatividadeHoras(
        typeof dados.inatividade_horas === 'number'
          ? dados.inatividade_horas
          : parseInt(dados.inatividade_horas || '4', 10)
      );
      setNovoLeadDias( // ← NOVO
        typeof dados.novo_lead_dias === 'number'
          ? dados.novo_lead_dias
          : parseInt(dados.novo_lead_dias || '2', 10)
      );
      setMensagemSaudacao(typeof dados.mensagem_saudacao === 'string' ? dados.mensagem_saudacao : '');

    } catch (err) {
      console.error('❌ Erro ao carregar configurações:', err);
      setMensagem('Erro ao carregar configurações.');
    } finally {
      setLoading(false);
    }
  };

  const carregarModelos = async () => {
    try {
      const res = await axios.get('https://welaunchyou.com.br/crm-wly/api/openai/modelos_disponiveis.php');
      const data = res.data;
      if (Array.isArray(data)) {
        setModelosDisponiveis(data);
      } else if (Array.isArray(data.modelos)) {
        setModelosDisponiveis(data.modelos);
      } else {
        console.warn('⚠️ Formato inesperado dos modelos:', data);
        setModelosDisponiveis([]);
      }
    } catch (err) {
      console.error('❌ Erro ao carregar modelos:', err);
      setModelosDisponiveis([]);
    }
  };

  const carregarLeads = async () => {
    try {
      const res = await axios.get('https://welaunchyou.com.br/crm-wly/getLeads.php', { withCredentials: true });
      if (Array.isArray(res.data)) setLeads(res.data);
    } catch (err) {
      console.error('Erro ao carregar leads:', err);
    }
  };

  useEffect(() => {
    if (modoTreinamento) carregarLeads();
  }, [modoTreinamento]);

  const salvar = async () => {
    setSalvando(true);
    setMensagem('');
    try {
      const payload = {
        usuario_id,
        modelo_openai: modelo,
        prompt_base: prompt,
        ia_ativa: iaAtiva ? 1 : 0,
        modo_treinamento: modoTreinamento ? 1 : 0,
        lead_treinamento_id: modoTreinamento ? leadTreinamentoId : '',
        memoria_dias: 3,
        inatividade_ativa: inatividadeAtiva ? 1 : 0,
        mensagem_inatividade: mensagemInatividade,
        inatividade_horas: Math.max(1, parseInt(inatividadeHoras || 4, 10)),
        novo_lead_dias: Math.max(1, parseInt(novoLeadDias || 2, 10)), 
        mensagem_saudacao: mensagemSaudacao,

      };

      await axios.post('https://welaunchyou.com.br/crm-wly/api/openai/configuracoes.php', payload);
      setMensagem('Configurações salvas com sucesso!');
    } catch (err) {
      console.error('❌ Erro ao salvar configurações:', err);
      setMensagem('Erro ao salvar configurações.');
    } finally {
      setSalvando(false);
    }
  };

  if (loading) return <p className="p-4">Carregando...</p>;

  return (
    <div className="configuracoes-container">
     {/* Ativar IA */}
<div className="mb-6">
  <label>Ativar IA:</label>
  <label className="switch">
    <input
      type="checkbox"
      checked={iaAtiva}
      onChange={() => {
        const novoValor = !iaAtiva;
        setIaAtiva(novoValor);

        if (novoValor) {
          // IA LIGADA => Treinamento deve ficar DESLIGADO
          if (modoTreinamento) setModoTreinamento(false);
        } else {
          // IA DESLIGADA => dependentes devem ficar DESLIGADOS
          if (inatividadeAtiva) setInatividadeAtiva(false);
          if (modoTreinamento) setModoTreinamento(false);
        }
      }}
    />
    <span className="slider round"></span>
  </label>
</div>

{/* Modo Treinamento */}
<div className="mb-6">
  <label className="label-treinamento">Modo Treinamento:</label>
  <div className="modo-treinamento-bloco">
    <label className="switch">
      <input
        type="checkbox"
        checked={modoTreinamento}
        onChange={() => {
          const novoValor = !modoTreinamento;
          if (novoValor) {
            // Treinamento LIGADO => IA e Inatividade DEVEM estar DESLIGADAS
            if (iaAtiva) setIaAtiva(false);
            if (inatividadeAtiva) setInatividadeAtiva(false);
            setModoTreinamento(true);
          } else {
            setModoTreinamento(false);
          }
        }}
      />
      <span className="slider round"></span>
    </label>

    <div className="alerta-treinamento">
      ⚠️ Quando ativado o <span>Modo Treinamento</span>, a IA responderá apenas o lead escolhido abaixo. Os demais
      serão ignorados.
    </div>
  </div>
</div>

      {/* Select Treinamento */}
      {modoTreinamento && (
  <div className="mb-6">
    <label>Selecionar lead para treinar:</label>
    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
      <select
        style={{ marginTop: 15 }}
        value={leadTreinamentoId}
        onChange={(e) => setLeadTreinamentoId(parseInt(e.target.value))}
        className="border p-2 rounded select-treinamento"
        disabled={limpando}
      >
        <option value="">Selecione um lead</option>
        {leads.map((lead) => (
          <option key={lead.id} value={lead.id}>
            {lead.nome} {lead.telefone ? `(${lead.telefone})` : ''}
          </option>
        ))}
      </select>

        <button
          type="button"
          onClick={limparHistorico}
          disabled={!leadTreinamentoId || limpando}
          className="btn-limpar-historico"
          title="Apaga mensagens, logs e pendências de envio deste lead"
          aria-busy={limpando}
          aria-disabled={(!leadTreinamentoId || limpando) ? 'true' : 'false'}
        >
          {limpando ? (
            <span className="btn-loading">
              <span className="spinner" aria-hidden="true"></span>
              Limpando…
            </span>
          ) : (
            'Limpar histórico'
          )}
        </button>
    </div>
  </div>

      )}


{/* Mensagem por Inatividade */}
<div className="mb-6">
  <div className={`inatividade-bloco ${!inatividadeAtiva ? 'inativo' : ''}`}>
    <label className="label-inatividade">Mensagem por inatividade:</label>
    <label className="switch">
      <input
        type="checkbox"
        checked={inatividadeAtiva}
        onChange={() => {
          const novoValor = !inatividadeAtiva;

          // Regra: Inatividade só pode ligar se IA estiver ligada
          if (novoValor && !iaAtiva) {
            setMensagem('Para ativar a Mensagem por Inatividade, ative a IA primeiro.');
            return;
          }
          // Também não pode estar em Treinamento
          if (novoValor && modoTreinamento) {
            setMensagem('Desative o Modo Treinamento para usar a Mensagem por Inatividade.');
            return;
          }

          setInatividadeAtiva(novoValor);
        }}
      />
      <span className="slider round"></span>
    </label>


          {!iaAtiva && (
            <div className="aviso-janela">
              ⚠️ Recurso exige <strong>Ativar IA</strong> ligado.
            </div>
          )}
          {iaAtiva && (
            <div className="aviso-janela">
              Os envios ocorrem entre <strong>08:00 e 20:00</strong>.
            </div>
          )}

          <div className="linha" style={{ marginLeft: '50px' }}>
  <label className="label">Horas sem resposta</label>
  <p>tempo que o lead precisa ficar sem enviar mensagem para ativar a mensagem por inatividade</p>
  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
    <input
      type="number"
      min={1}
      value={inatividadeHoras}
      onChange={(e) => setInatividadeHoras(e.target.value)}
      className="input horas-input"
      disabled={!inatividadeAtiva || !iaAtiva}
      placeholder="4"
    />
    <span>hora(s)</span>
  </div>
</div>

<div className="linha" style={{ marginLeft: '50px' }}>
  <label className="label">Dias para considerar “lead novo”</label>
  <p>Somente leads cadastrados nos últimos X dias receberão a mensagem de inatividade.</p>
  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
    <input
      type="number"
      min={1}
      value={novoLeadDias}
      onChange={(e) => setNovoLeadDias(e.target.value)}
      className="input horas-input"
      disabled={!inatividadeAtiva || !iaAtiva}
      placeholder="2"
    />
    <span>dia(s)</span>
  </div>
</div>


          <div className="linha-coluna" style={{ marginLeft: '50px' }}>
            <label className="label">Mensagem de inatividade (opcional)</label>
            <textarea
              rows={4}
              value={mensagemInatividade}
              onChange={(e) => setMensagemInatividade(e.target.value)}
              disabled={!inatividadeAtiva || !iaAtiva}
              placeholder="Deixe em branco para a IA gerar automaticamente uma mensagem curta e amigável."
              className="textarea"
            />
            <p className="hint">Se deixar em branco, a IA gera automaticamente uma mensagem curta e amigável.</p>
          </div>
        </div>
      </div>

        {/* Mensagem de Saudação (primeiro contato) */}
<div className="mb-6">
  <label>Mensagem de saudação (primeiro contato)</label>
  <textarea
    rows={3}
    placeholder="Ex.: Olá! Que bom receber seu contato 😊 Vou te enviar as informações agora."
    value={mensagemSaudacao}
    onChange={(e) => setMensagemSaudacao(e.target.value)}
  />
  <p className="hint">Se deixar em branco, a IA usará uma saudação padrão curta.</p>
</div>



      {/* Prompt Base */}
      <div className="texto-prompt">
        <label>Prompt Base</label> <p>(quanto mais detalhes, mais inteligente a resposta):</p>
        <textarea
          rows="8"
          placeholder="Digite aqui o prompt de treinamento do seu Agente IA (veja exemplos abaixo)!"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
        />
      </div>

      <button onClick={salvar} disabled={salvando}>
        {salvando ? 'Salvando...' : 'Salvar'}
      </button>

      {mensagem && <p className="mensagem">{mensagem}</p>}

      {/* exemplos… (mantive o seu bloco) */}
      <div className="texto-exemplo-prompt">
        <p>
          <strong>Exemplos de prompts para treinamento do Agente IA</strong>
        </p>
      <p><strong>Você é Samwise</strong>, mas pode pedir para te chamarem de <strong>Sam</strong>.<br></br>
Atua como atendente da empresa Nórea, com linguagem simpática, acessível e profissional.</p>

<p>Responda com <strong>até 250 caracteres</strong>, organizando em <strong>parágrafos curtos</strong>.</p>

<p><strong>Regras importantes:</strong><br></br>
- Não repetir saudações como "Oi", "Olá" na mesma conversa<br></br>
- Sempre perguntar o nome da pessoa, uma vez na conversa<br></br>
- Nunca fornecer preços ou valores<br></br>
- Não usar hashtags<br></br>
- Não oferecer atendimento humano antes de 10 mensagens (exceto se for solicitado)</p>

<p><strong>Se perguntarem sobre preços:</strong><br></br>
“O valor pode variar conforme a estratégia ideal. Posso pedir para um especialista te explicar melhor.”</p>

<p><strong>Se pedirem para falar com um humano:</strong><br></br>
“Vou direcionar você para uma especialista. Um momento por favor.”<br></br>
Retorne a tag: [PENDENTE]</p>

<p><strong>Casos específicos:</strong><br></br>
- Gravação gratuita apenas para marketing nas redes sociais. Pergunte antes:<br></br>
“Esse vídeo seria para redes sociais ou para outro uso?”<br></br>
- Não fazemos tráfego pago no Google Ads ou TikTok Ads<br></br>
- Para perguntas fora do escopo:<br></br>
“Desculpe, não posso ajudar com isso no momento. Gostaria de conversar com nosso diretor?”</p>

<p><strong>Portfólio:</strong><br></br>
Acesse: noreamkt.com.br</p>

<p><strong>Trabalhos que oferecemos:</strong><br></br>
- Gestão de tráfego Pago<br></br>
- Produção e Edição de vídeos<br></br>
- Desenvolvimento Web<br></br>
- Desenvolvimento de Sistemas<br></br>
- Produções audiovisuais em geral</p>
</div>
      </div>
  );
};

export default ConfiguracoesIA;
